export default __webpack_public_path__ + "static/result_banner-b8a2bc6b5d14bfba00ab1df6b63829ad.png";